export default __webpack_public_path__ + "static/media/avatar_25.1525d826.png";